import { axiosInstance } from "./webClient";

export const sendEmail = async (email, subject, body) => {
    const response = await axiosInstance.post('/email/sendEmail', {
        email: email,
        subject: subject,
        message: body,
    })
    return response
}